<template>
	<div class="background">
		<div class="callBox" :id='call.callid' :class='{mobile: cxMobile, selected: this.selected}'>
			<callDetailsRow avoidDefaultClass="true" :class='{live: call.islive}' > 
				<div slot="rowContent" class="callBoxTopBar">
					<div class='headerStatus'>
						<i class="zmdi zmdi-dot-circle-alt unaddressedIcon" v-if='!call.islive' :class="{inactive: !unaddressed}" @click="unaddressedPop = true; selected = true"></i>
						<i class='zmdi zmdi-circle live' v-else> </i>
						<i class="zmdi zmdi-mood-bad" v-if='call.sentimentNeg'></i>
					</div>

					<i class='zmdi zmdi-account-box-phone headerIcon' v-if='call.islive'></i>
					<i class="zmdi zmdi-phone headerIcon" v-else></i>

					<label class="headerText" :id='call.callId' @click='showEditPop()' v-if='!call.islive'>{{ call.disposition_condensed }}</label>
					<div class='headerTextLive' v-else>
						<label>{{ call.label1 || call.dnis_ringto }}</label>
						<div class='headerTrackingLineLabel' v-if='call.dnis_extension'>
							<i class='zmdi zmdi-phone-forwarded'></i>
							<label class='sub'>{{ call.dnis_extension }}</label>
						</div>
					</div>

					<div class="headerLabels">
						<div class='headerLabelsTop'>
							<div class="imgWrap" @click='showEditPop()'>
								<img v-if='call.agent && call.agent.Phonecode.pc_avatar' :src="call.agent.Phonecode.pc_avatar" >
								<label v-else-if='call.agent' class="sidebarImageReplacement">{{ getInitials(call.agent.Phonecode.lename) }}</label>
								<img v-else src="https://assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_unknown.jpg" >
							</div>

							<div class='headerImageLabels' v-if='!cxMobile'>
								<label v-if='call.agent && call.agent.Phonecode'>{{ call.agent.Phonecode.lename }}</label>
								<label v-else-if='!call.agent && !call.islive' :class='{headerImageLabelMobile: cxMobile}'>Unknown</label>
								<button @click='showEditPop()' v-else>ASSIGN</button>
							</div>
						</div>
					</div>
					<i class="zmdi zmdi-edit edit" v-if='!(call.islive || cxMobile)' @click='showEditPop()'></i>
				</div>
			</callDetailsRow>

			<callDetailsRow v-if='!call.islive && (!cxMobile || cxMobileExpanded)' optionalClass="trackingLineRow">
				<div class="flex" slot="rowContent">
					<i class="zmdi zmdi-account-box-phone"></i>
					<div class='trackingLineLabels'>
						<div class="trackingLineLabel">{{ call.label1 || call.dnis_ringto }}</div>
						<div v-if='call.dnisfunctionid !== 2' class="trackingLineNumber">
							{{ call.displaynum }}
							<span class='trackingLineExtension' v-if='call.dnis_extension'> ({{ call.dnis_extension }})</span>
						</div>
					</div>
				</div>
			</callDetailsRow>

			<callDetailsRow v-if="transcript && (!cxMobile || cxMobileExpanded)" optionalClass="transcriptRow">
				<div slot="rowContent" class="flex">
					<i class="zmdi zmdi-rotate-left"></i>
					<div class="transcriptText" :id='call.callId' @click='showEditPop()'>
						<div class='transcriptContent'>{{ transcript }}</div>
						<div class="translated" v-if='[2,5,12,13].indexOf(call.review_classid) > -1'>
							<i class="zmdi zmdi-globe-alt"></i>
							<i>Translated From a Foreign Language</i> 
						</div>
					</div>
				</div>
			</callDetailsRow>

			<callDetailsRow v-if="callCenterOutcomeFeatureEnabled && (!cxMobile || cxMobileExpanded)" optionalClass="dispositionRow">
				<div slot="rowContent" class="dispositionButtonContainer">
					<div class='callOutcomes' v-if='(callidsThatHavePriorOutcomes[call.callid] && outcome.hasBeenReviewed) || outcome.body !==""'>
						<i class="zmdi zmdi-collection-text"></i>
						<div class='outcomesBody'>
							<label class='sub'>Call Outcomes</label>
							<div class="outcomesBodyText">{{outcome.body}}</div>
							<label class='small submittedBy'>Submitted By: {{outcome.uploadedBy}} {{outcome.uploadedTime}}</label>
						</div>
					</div>
					<button class="dispositionButton" v-else @click="outcome.beingSet = true; selected = true">
						<i class="zmdi zmdi-plus-circle"></i> OUTCOME
					</button>
				</div>
			</callDetailsRow>

			<callDetailsRow v-if='(call.islive) && (!cxMobile || cxMobileExpanded) && jiveLskins.indexOf(this.account.lskinid) == -1'>
				<div class="liveRow" slot="rowContent">
					<joinACallWidget v-if='this.liveButton' :messageindex="this.messageindex" :callid='call.callid' :JACmobile='cxMobile'/>
				</div>
			</callDetailsRow>

			<callDetailsRow v-if='!(call.islive) && (!cxMobile || cxMobileExpanded)'>
				<div class="callRow" slot="rowContent">
					<div class='noAudio' v-if='((this.audioMetadataLoadAttempted || this.audioLoadAttempted) && !audio) || (audio && !audio.audiofileembed && !audio.recording_killed) || (audio && audio.recording_killed) || (audio && audio.audiofileembed.indexOf("sensitive_removed") > -1)'>
					</div> 

					<div class='placeholderPlayer' :id='call.callid' v-else-if='!audioLoadAttempted && !this.localState.loaded && !audio.recording_killed'>
						<i class='zmdi zmdi-play' :id='call.callid' @click='grabAudioData()'></i>
						<label class='small startTime'>0:00</label>					
						<div class='audioBlankLine'></div>
						<label class='small endTime'>{{ this.trueDuration }}</label>
					</div>

					<!-- Load audio just to get the audio file duration... -->
					<audio preload="metadata" v-if='this.audioMetadataLoadAttempted && audio.audiofileembed && !this.legacySensitive && !audio.recordingKilled' ref='hiddenAudio' @loadeddata='getDuration()' :src='audio.audiofileembed'></audio>

					<audioPlayer :message='call' :audio='audio' :trueDuration='this.trueDuration' :floatDuration='this.floatDuration' :currentTimeProp='this.currentTime' v-if='this.localState.loaded && audio.audiofileembed' />

					<div class="buttonsContainer">
						<i class="zmdi zmdi-volume-off" v-if="(!audio || ((audio && !audio.audiofileembed)) && (audio && !audio.recording_killed))" title="No Audio"></i>
						<i class="zmdi zmdi-time-restore" v-else-if="audio && audio.redactionPending" title="This call audio has yet to go through our sensitive information removal process."></i>
                		<i class="zmdi zmdi-volume-off" v-if="audio && audio.recording_killed" title="Audio Manually Removed"></i>
                		<i class="zmdi zmdi-volume-off alert2" v-if="audio && audio.audiofileembed && audio.audiofileembed.indexOf('sensitive_removed') > -1" title="Sensitive Personal Information redacted from call."></i>
						<i class="zmdi zmdi-share button" :id='call.callid' @click='callInfoSlide += 1; sharePop()' v-if='!cxMobile'></i>
						<i class="zmdi zmdi-info button" :id='call.callid' @click='sharePop()'></i>
					</div>
					<div :id='call.callid' class="callid">{{ call.callid }}</div>
	            </div>
	        </callDetailsRow>
            <callDetailsRow v-if="(seenCallsFeatureflag && seenby.length > 0 && !cxMobile) || (seenCallsFeatureflag && seenby.length > 0 && cxMobile && cxMobileExpanded)">
	            <div class="callBoxRow seenCallsRow" slot="rowContent">
	            	<i class="zmdi zmdi-eye" :class="{newRecord: (seenby[0].insertTime && (triggerTime - seenby[0].insertTime < 9000) && ( triggerTime - seenby[0].insertTime > 6000))}"></i>
	                <div class="seenWrap">
	                	<i class="zmdi zmdi-chevron-left seenButton" @click="rewindSeen()" :class="{validButton: seenby.length > 3 && seenCallsViewingIndex > 0}"></i>
	                    <div class="seenCallsContainer desktop">
	                        <div class="seenCallsRecord" v-for="(seenrecord, index) in seenby" v-if="(index >= seenCallsViewingIndex && index < seenCallsViewingIndex + 4) && !seenrecord.internalUser">
	                            <div class="imgWrap">
	                                <img :src="seenrecord.userImg" class="reviewerImage" v-if="seenrecord.userImg">
	                                <img src="//assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_2.jpg" class="reviewerImage" v-else>
	                            </div>
	                            <div class="seenRecordNameInfo">
	                            	<div class='seenRecordNameInfoTop'>
                            		<label class="sub seenRecordUserName" @click="callActionHistoryPop = true; pullActionHistory()">{{seenrecord.name}}</label>
	                            		<div class="seenCallsAction" v-for="action in seenactions" v-if="action.userid === seenrecord.userid">
											<i class="zmdi zmdi-edit actionIcon" v-if="action.actionType === 40"></i>
												<!-- CHANGE THIS TO THE ACTUAL ACTION TYPE -->
											<i class="zmdi zmdi-share actionIcon" v-if="action.actionType === 5"></i>
											<i class="zmdi zmdi-volume-up actionIcon" v-if="action.actionType === 2"></i>
	                                	</div>
	                                </div>
	                                <div class="disclaimer seenRecordTimeStamp">{{seenrecord.time}}</div>
	                            </div>
	                        </div>
	                    </div>
	                    <i class="zmdi zmdi-chevron-right seenButton" @click="advanceSeen()" :class="{validButton: seenby.length > 3 && seenCallsViewingIndex < seenby.length - 1}"></i>

                    <i class="zmdi zmdi-more-vert openCallHistOption" @click="callActionHistoryPop = true; pullActionHistory()"></i>
                </div>
	            </div>
	        </callDetailsRow>

	        <callDetailsRow  v-if='cxMobile'>
	            <div class="callBoxRow mobileExpandRow" :class='{flip: cxMobileExpanded}' @click='cxMobileExpanded = !cxMobileExpanded' slot="rowContent">
					<i class='zmdi zmdi-chevron-down'></i>
				</div>
			</callDetailsRow>
		</div>

		<DispositionPopup 
			:showDispositionPop="callCenterOutcomeFeatureEnabled && outcome.beingSet && outcome.body === ''" 
	        @closingDisposition="outcome.beingSet = false; selected = false" 
	        :messageindex="this.messageindex"
	        :callCenterOutcomes="this.callCenterOutcomes"
	        :callid='call.callid' 
	        @sending="getCustomHcos"
	        @dispositionComplete="mountDispositionString"
	    />

		<!-- call info/share popup -->
		<article class='popupBG' v-if='localState.shareMode'>
			<div class='popup wide' :id='call.callid'>
				<div class='title'>
					<h2 v-if="callInfoSlide !== 2">Call Info</h2>
					<h2 v-else>Share Call</h2>
					<div class='close' @click='hideSharePop()'></div>
				</div>
				<div class='content' v-if="callInfoSlide == 1">
					<p v-if='isie === "true"' class='error'>
						Your current version of Internet Explorer does not support all available Artificial Intelligence features. View in Google Chrome, Mozilla Firefox, Microsoft Edge, or Safari to see more information about this call.
					</p>
					<p v-if='audio && audio.audiofileembed && !this.legacySensitive && !audio.recording_killed && secondsRemoved > 0'>
						This recording has been compressed for faster review. We removed {{ this.secondsRemoved }} seconds of dead air and hold time. To review the original recording, click <span @click='download()' class='link'>here.</span>
					</p>
					<p v-if='audio && audio.audiofileembed && audio.audiofileembed.indexOf("sensitive_removed") > -1 && !audio.recording_killed && !this.legacySensitive' class="error">
						Sensitive Information removed from this call
					</p>
					<p v-if='audio && !audio.audiofileembed && !audio.recording_killed'>
						This audio is unavailable.
					</p>
					<p v-if='audio && audio.audiofileembed && audio.recording_killed'>
						Audio from this call was intentionally removed by the agent handling the call. This call will not go through call categorization.
					</p>
					<p v-if='audio && audio.audiofileembed && this.legacySensitive'>
						Audio removed due to sensitive information
					</p>
				</div>
				<div class="content" v-else>
					<sliderTemplate classOption="slider" buttonNumber='2' v-if="crmOptions.length">
						<button :class="{active: sendToEmail}" @click="sendToEmail = true; sendToCRM = false" slot="firstButton"> 
							Email 
						</button>
						<button :class="{active: sendToCRM}" @click="sendToEmail = false; sendToCRM = true" slot="secondButton">
							CRM
						</button>
					</sliderTemplate>
					<div v-if="sendToEmail || !crmOptions.length">
						<div class='emailShare'>
							<label for='emailShare'>To</label>
							<inputTemplate :hasIcon='false' :hasLabel='false' :hasButton='false'>
								<input type="email" id="emailShare" v-model='shareCallRecipient' placeholder="Manually Enter Email Address(es)" slot='inputEl'>
							</inputTemplate>
							<multiselect v-model="shareCallRecipients" :options="options" :multiple="true" placeholder="Select Multiple Email Address(es)"></multiselect>
						</div>
						<div class='emailMsg'>	
							<label for='sendToEmailMsg'>Message</label>
							<textarea id='sendToEmailMsg' v-model='shareCallMessage' placeholder='Enter Message...'></textarea>
						</div>
					</div>
					<div v-if="sendToCRM">
						<div class="crmHistorySection" v-if="crmShareHist.length > 0">
							<label>Already Sent</label>
							<div v-for="history in crmShareHist" class="crmHistory">
								<label class='sub'>{{history.crmName}}</label>
								<div class='disclaimer'>{{ formatDatetime(history.dateTime) }}</div>
							</div>
						</div>
						<singleSelect :hasIcon="false" :hasLabel="false">
							<select class='crmSelect' ref="crmSelection" slot="singleSelectMain">
								<option selected disabled>Select Share Type</option>
								<option v-for="crm in crmOptions" :value='crm.xxml_joinid'>{{crm.shareref}}</option>
							</select>
						</singleSelect>
					</div>
				</div>
				<div class='buttons' v-if="callInfoSlide == 1">
					<button :id='call.callid' @click="callInfoSlide += 1"><i class='zmdi zmdi-share'></i>share call</button>
					<button :id='call.callid' v-if='audio && audio.audiofileembed && audio.recording_killed === false && !this.legacySensitive' @click='download()' class='alt'><i class='zmdi zmdi-download'></i>download audio</button>
				</div>
				<div class='buttons' v-else>
					<button v-if="sendToCRM" :id='call.callid' class="shareButton" @click='sendCallToCRM()'>Send To CRM</button>
					<button v-else :id='call.callid' @click='saveShare()'>Send Email</button>
					<p class='success' v-if="localState.sharePopConfirm !== ''">{{localState.sharePopConfirm}}</p>
				</div>
			</div>
			<div class='popupCloseWrap' @click='hideSharePop()'></div>
		</article>

		<!-- Edit call popup--->
		<article class='popupBG' v-if='localState.editMode'>
			<div class='popup wide' :id='call.callid'>
				<div class='title'>
					<h2>Edit</h2>

					<div class='close' @click='hideEditPop()'></div>
				</div>

				<div class='content scroll'>
					<div class="editAgentSection">
						<div class='imgWrap' v-if='call.agent && call.agent.Phonecode'>
							<img v-if='call.agent.Phonecode.pc_avatar' :src="call.agent.Phonecode.pc_avatar">
							<img v-else src="https://assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_2.jpg" >
						</div>
						<div class='imgWrap' v-else>
							<img src="https://assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_unknown.jpg" >
						</div>

						<singleSelect optionalClass="fusedInput" :hasButton="true">
							<select v-model='call.agentSelected' slot="singleSelectMain">
								<option class="cxOption" :value='undefined || null'>Choose Handler</option>
								<option class="cxOption" v-for='obj in agents' :value='obj'> Handled By: {{ obj.Phonecode.lename }} </option>
							</select>
							<button @click='updateAgent()' slot="selectButton">Submit</button>
						</singleSelect>
					</div>
					<p class='success updatedHandledBy'>{{ this.localState.handledByConfirm }}</p>
				
					<Audit 
						v-if="allowReview"
						:call='call'
						:transcript='this.transcript'
						:messageindex ='messageindex'
						@edited-call="hideEditPop()"
					/>
				</div>
			</div>

			<div class='popupCloseWrap' @click='hideEditPop()'></div>
	    </article>

		<UnaddressedPopup :unaddressedPop="unaddressedPop" :unaddressedNotes="unaddressedNotes" :unaddressed="unaddressed" :accountRefname="account.refname" :loadingUnaddressedChange="loadingUnaddressedChange" 
			@submit-unaddressed-change="submitUnadressedChange()" @close-unaddressed-pop="unaddressedPop = selected = false"></UnaddressedPopup>

	    <article class='popupBG'  v-if="callActionHistoryPop">
	      	<div class='popup unaddressed'>
		        <div class='title'>
		          <h2 class="callActionHistTitle">Action History</h2>
		          <div class='close' @click="callActionHistoryPop = false"></div>
		        </div>
		        <div class="content scrolling">
                  <div v-for="action in callActionHistory" class="callActionHistory">
                    <div class="flex between">
                        <div class="flex">
                            <img :src="action.userImg" class="callActionImg" v-if="action.userImg">
                            <img src="https://assets-cdn.carwars.com/cw/avatar-placeholders/placeholder_2.jpg" class="callActionImg" v-else>
                            <label class="callActionUser">{{action.userName}}</label>
                        </div>
                        <div>
                            {{action.time}}
                        </div>
                    </div>
                    <div class="flex callActionHistoryIcons">
                        <div class="actionType" v-if="action.listened">
                            <i class="zmdi zmdi-volume-up actionIcon"></i> <label class="sub">Played Audio</label>
                        </div>
                        <div class="actionType" v-if="action.shared">
                            <i class="zmdi zmdi-share actionIcon"></i> <label class="sub">Shared</label>
                        </div>
                        <div class="actionType" v-if="action.seen">
                           <i class="zmdi zmdi-eye actionIcon"></i> <label class="sub">Seen</label>
                        </div>
                    </div>
                    <div v-if="action.updatedTo" class="callActionHistoryUpdateOutcome flex"  v-for="action_description in action.updatedTo">
                        <i class="zmdi zmdi-edit actionIcon"></i>
                        <div>{{action_description}}</div>
                    </div>
                  </div>
                </div>
		    </div>
	      	<div class='popupCloseWrap' @click="callActionHistoryPop = false"></div>
	    </article>
	</div>	
</template>

<script>
import $ from 'jquery'
import audioPlayer from '@/components/audioPlayer'
import Audit from '@/components/Audit'
import axios from 'axios'
import moment from 'moment-timezone'
import * as AWS from 'aws-sdk'
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'
import 'url-polyfill'
import joinACallWidget from '@/components/joinACall'
import callDetailsRow from '@/components/callDetailsRow'
import sliderTemplate from '@/components/slider.vue'
import inputTemplate from '@/components/inputTemplate.vue'
import singleSelect from '@/components/singleSelect.vue'
import DispositionPopup from '@/components/DispositionPopup'
import UnaddressedPopup from '@/components/UnaddressedPopup'
require('../assets/css/cxDetails.css?1')

export default {
  name: 'cxDetails',
  props: [
	  	"messageindex", 
	  	"options", 
	  	'cxMobile', 
	  	'checkFirstCX', 
	  	'lastCX', 
	  	'callidsThatHavePriorOutcomes', 
	  	'seenby', 
	  	'triggerTime', 
	  	'seenactions', 
	  	'crmInfo', 
	  	'unaddressed', 
	  	'displayNum', 
	  	'trackinglinename'
  	],
  components: { 
	  audioPlayer,
	  Audit,
	  Multiselect,
	  joinACallWidget,
	  callDetailsRow,
	  sliderTemplate,
	  inputTemplate,
	  singleSelect,
	  DispositionPopup,
	  UnaddressedPopup
	},
  computed: {
    ...mapState({
		account: state => state.account,
		call (state) {
			return state.currentMessages[this.messageindex]
		},
		agents: state => state.agents,
		user: state => state.user,
		cftoken: state => state.cftoken,
		cfid: state => state.cfid,
		liveListenDID: state => state.liveListenDID,
		liveButton: state => state.liveButton,
		callCenterOutcomeFeatureEnabled: state => state.callCenterOutcomeFeatureEnabled,
		callCenterOutcomes: state => state.callCenterOutcomes,
		jiveLskins: state => state.jiveLskins,
		redactionEnabled: state => state.redactionEnabled,
		callmeasurementAPIToken: state => state.callmeasurementAPIToken,
		unaddressedNotes (state) {
			return state.unaddressedLogMap[this.call.callid];
		}
	  }),
	transcript: {
		get: function () {
			return this.call.call_summ;
		},
		set: function (newTranscript) {
			this.call.call_summ = newTranscript;
		}
	},
	newestCX: {
		get: function () {
			if (this.lastCX == this.messageindex) {
				this.cxMobileExpanded = true;
				return true
			}
			else {
				this.cxMobileExpanded = false;
				return false
			}
		},
		set: function (bool) {
			this.newestCX = bool;
		}
	},
	review_classid () {
		return this.call.review_classid;
	}
  },
  data: function () {
    return {
    	callActionHistoryPop: false,
    	callActionHistory: [],
    	selected: false,
    	sendToEmail: true,
    	sendToCRM: false,
    	crmShareHist:[],
    	crmOptions:[],
    	unaddressedPop:false,
		showMoreUnaddressed:false,
    	legacySensitive: false, 
    	seenCallsViewingIndex: 0,
    	seenCallsFeatureflag: true,
		allowReview: true,
    	legacySensitive: false,
			localState: {
				playing: false,
				paused: true,
				loaded: false,
				editMode: false,
				shareMode: false,
				shareExpand: false,
				ctcMode: false,
				audioInfo: false,
				handledByConfirm: '',
				sharePopConfirm: '',
				listenLive: false,
				invalidPhone: false, 
				initiatingCall: false
			},
			callInfoSlide: 1,
			shareCallMessage: '',
			shareCallRecipient: '',
			shareCallRecipients: [],
			directPhoneInput: '',
			trueDuration: '0:00',
			floatDuration: 0, 
			currentTime: '0:00',
			secondsRemoved: 0,
			isie: false,
			audio: '',
			audioLoadAttempted: false,
			audioMetadataLoadAttempted: false,
			audioCompression: '',
			cxMobileExpanded: false,
			legacySensitive: false,
		outcome: {
				featureActive: true,
				beingSet: false,
				hasBeenReviewed: false,
			uploadedBy: '',
			uploadedTime: '',
			body: ''
		},
		loadingUnaddressedChange:false,
    }
	},
	beforeMount: function() {
		this.crmOptions = this.crmInfo.filter(x => x.frn_dnisfunctionid == this.call.dnisfunctionid);
	},
  mounted: function() {
    this.directPhoneInput = this.liveListenDID
		this.isie = this.checkIE()
    this.$emit('checkFirstCX')
		this.checkFirst()
		this.loadAudioMetadata()
	},
	created() {
    this.$on('callSave', () => {
      this.updateAgent();
    })

    this.$on('transcript', (transcript) => {
      this.transcript = transcript;
    })

    this.$on('dispositionCondensed', (dispositionCondensed) => {
		this.call.disposition_condensed = dispositionCondensed;
	})

	if (this.call.outcome && this.call.outcome !== '') {
		this.outcome.body = this.call.outcome;
		this.outcome.uploadedBy = this.call.outcome_by;
		this.outcome.uploadedTime = moment(this.call.outcome_on).format("l");
	}

		if (this.crmOptions) {
			this.pullCRMHistory();
		}
  },
  methods: {
  	pullActionHistory: async function(){
		let array = []
		let endpoint = `/calls/seen/action_description/${this.call.callid}`;

		let res = await this.axios.get(endpoint);
		for (let i = 0; i < this.seenby.length; i++){
			// loop through actions that a particular user has taken
			for (let j = 0; j < this.seenactions.length; j++){
				if (this.seenby[i].userid == this.seenactions[j].userid){
					if (this.seenactions[j].actionType == 5){
						this.seenby[i].callShared = true
					}
					if (this.seenactions[j].actionType == 2){
						this.seenby[i].listened = true
					}
					if (this.seenactions[j].actionType == 40){
						// when user has actionType = 40 we want to loop through the action_descriptions and find the one that matches the userid
						this.seenby[i].action_description = []
						for (let k = 0; k < res.data.length; k++){
							if (this.seenactions[j].userid == res.data[k].leuserid){
								this.seenby[i].action_description.push(res.data[k].action_description)
							}
						}                              
					}                        
				}
			}
			// push the data for actions taken by a user into an array
			array.push({
				userImg: this.seenby[i].userImg,
				userName: this.seenby[i].name,
				seen: true,
				listened: this.seenby[i].listened,
				shared: this.seenby[i].callShared,
				updatedTo: this.seenby[i].action_description,
				time: this.seenby[i].time
			})
		}
		this.callActionHistory = array
  	},
  	getInitials: function (name) {
      let nameArray = name.trim().split(' ');
      let initials = '';
      
      if (nameArray.length === 2) {
        initials += nameArray[0][0];
        initials += nameArray[1][0];
      } else if (nameArray.length > 2) {
        initials += nameArray[0][0];
        initials += nameArray[nameArray.length-1][0];
      } else if (nameArray.length === 1) {
        initials += nameArray[0][0];
      }

      return initials;
    },
  	sendCallToCRM: async function(){
			let endpoint = `/calls/${this.call.callid}/share/crm`;
			
			let res = await this.axios.post(endpoint, {
				xxml_joinid: this.$refs.crmSelection.value,
				leuserid: this.user.leuserid
			});

			if(res){
				this.hideSharePop(this.call.callid)
			}
  	},
	checkRoles: async function() {
		let that = this
		let roles = ["Medical: Call Center Staff","Multifamily: Leasing Staff","Medical: Call Center Staff",
		"Medical: Office Staff/Receptionist","Automotive: Guest Services/Receptionist",
		"Automotive: Salesperson","Automotive: BDC Agent/Rep","Automotive: Service Advisor",
		"Home Services: CSR (Customer Service Rep)","Other: Location Staff"]
		for(let index in that.user.roles) {
			if(roles.indexOf(that.user.roles[index].contact_role) > -1){
				that.allowReview = false;
			};
		}
	},
  	pullCRMHistory: async function(){
		let endpoint = `/calls/${this.call.callid}/share/crm/history`;
		let res = await this.axios.get(endpoint);
  		this.crmShareHist = res.data;
  	},
	formatDatetime: function (timestamp, preserve) {
		if (preserve) {
			return moment(timestamp).format('MMMM DD, YYYY hh:mm A');
		} else {
			return moment(timestamp).add(moment.tz.zone('America/Chicago').utcOffset(moment(timestamp)) / 60, 'hours').format('MMMM DD, YYYY hh:mm A');
		}
	},
  	submitUnadressedChange: async function () {
  		this.selected = false;
  		this.loadingUnaddressedChange = true;
		this.unaddressedPop = false;
		const markedAs = !this.unaddressed;
		const today = moment().format('MMMM DD, YYYY hh:mm A');
		const endpoint = `https://callmeasurement-api.callbox.com/unaddressed/call/${this.call.callid}`;

		if (!this.callmeasurementAPIToken) {
			await this.$store.dispatch('getCallmeasurementAPIToken');
		}

		if (this.unaddressed) {
			let res = await axios.put(endpoint, {
				unaddressed: false,
				userid: this.user.leuserid
			}, {
				headers: {
					Authorization: `Bearer ${this.callmeasurementAPIToken}`
				}
			});

			this.$emit('toggleUnaddressed', {
				unaddressed: false,
				index: this.messageindex,
				datetime: this.call.tz_datetime
			})
		} else {
			let res = await axios.put(endpoint, {
				unaddressed: true,
				userid: this.user.leuserid
			}, {
				headers: {
					Authorization: `Bearer ${this.callmeasurementAPIToken}`
				}
			});

			this.$emit('toggleUnaddressed', {
				unaddressed: true,
				index: this.messageindex,
				datetime: this.call.tz_datetime
			})
		}

		this.$store.commit('addUnaddressedLog', { ActionDatetime: today, descrip1: this.user.descrip1, FlaggedAs: markedAs, CommunicationId: this.call.callid, preserve: true });
		this.loadingUnaddressedChange = false
	},
  	advanceSeen: function(){
      if(this.seenCallsViewingIndex < this.seenby.length - 1){
        this.seenCallsViewingIndex++
      }
    },
    rewindSeen:function(){
      if(this.seenCallsViewingIndex > 0){
        this.seenCallsViewingIndex--
      }
    },
  	mountDispositionString: function(value){
  		if (value !== '') {
			this.outcome.body = value;
			this.outcome.uploadedBy = this.user.descrip1;
			this.outcome.uploadedTime = moment().format("l");
  		}
  	},
  	getCustomHcos: function(){
  		this.outcome.hasBeenReviewed = true
  		var that = this
  		setTimeout(function(){ that.outcome.beingSet = false }, 3000);
  	},
  	checkFirst: function () {
  		if ((this.messageindex == this.lastCX) && this.cxMobile) {
  			this.cxMobileExpanded = true;
  		}
  		else{
  			this.cxMobileExpanded = false;
  		}
  	},
 	showEditPop: function (){
		this.checkRoles()
		this.localState.editMode = true;
		this.localState.shareMode =  false;
		this.localState.ctcMode =  false;
		this.selected = true;
	},
 	expandShare: function () {
 		this.localState.shareExpand = true;
 	},
 	expandShare: function () {
 		this.localState.shareExpand = true;
 	},
 	getDuration: function () {
 		this.floatDuration = this.$refs.hiddenAudio.duration
		this.trueDuration = this.formatTime(this.$refs.hiddenAudio.duration)
	},
	getCurrentTime: function () { 
		this.currentTime = this.formatTime(this.$refs.hiddenAudio.currentTime)
		this.currentTimeRaw = this.$refs.hiddenAudio.currentTime
	},
	formatTime: function (time) {
		return [
			Math.floor((time % 3600) / 60),
			('00' + Math.floor(time % 60)).slice(-2)
		].join(':')
	},
	formatLeminutes: function (leminutes) {
		let hDiv = leminutes / 60;
		let h = Math.floor(hDiv);
		let hRemainder = hDiv - h;

		let mDiv = hRemainder * 60;
		let m = Math.floor(mDiv);
		let mRemainder = mDiv - m;

		let sDiv = mRemainder * 60;
		let s = Math.floor(sDiv);

		let arr = [];

		h ? arr.push(h) : ''
		m ? arr.push(m) : arr.push('0')
		s ? arr.push(s) : arr.push('00')

		return arr.length ? arr.join(':') : '0:00'
	},
	loadAudioMetadata: async function () {
		let endpoint = `calls/audio/${this.call.callid}`;
		let redactionBool = this.jiveLskins.indexOf(this.account.lskinid) == -1 ? this.redactionEnabled : false;
		let endpointAPI = `callaudio/${this.call.callid}/getSignedUrl/${redactionBool}`;


		let res = await this.axios.get(endpoint);
		let audio = res.data;
		this.audio = audio;

		if (audio.audiofileembed === 'sensitive_removed') {
			this.legacySensitive = true;
		}
        
		let resAPI = await this.axios.get(endpointAPI);

		if (!resAPI.data['redactionBool']) {
			this.audio['redactionPending'] = true
		}

		if (audio && audio != ''){
			resAPI.data['APIresult'] != 'No Audio'? this.audio.audiofileembed = resAPI.data['APIresult'] : this.audio.audiofileembed = null;
		}

		this.audioMetadataLoadAttempted = true;
	},
	grabAudioData: async function () {
		let audio = this.audio;
		if(audio && audio.audiofileembed && (audio.audiofileembed !== 'sensitive_removed' || !this.legacySensitive) && !audio.recording_killed) {
			this.loadWaveForm();
		}
		this.audioLoadAttempted = true;
	},
	grabCompressionData: async function () {
		let endpoint = `calls/audioCompression/${this.call.callid}`;
		let res = await this.axios.get(endpoint);
		let audioCompression = res.data;
		this.secondsRemoved = this.getSecondsRemoved();
		this.audioCompression = audioCompression;
	},
 	hideEditPop: function(){
		this.localState.editMode = false;
		this.localState.shareMode =  false;
		this.localState.ctcMode =  false;
		this.localState.handledByConfirm = '';
		this.call.agentSelected = this.call.agent;
		this.selected = false;
	 },
 	download: async function () {
		try {
			const redactionBool = this.jiveLskins.indexOf(this.account.lskinid) === -1 && this.redactionEnabled;
			const endpointAPI = `callaudio/${this.call.callid}/getSignedUrl/${redactionBool}`;

			const resAPI = await this.axios.get(endpointAPI);
			window.open(resAPI.data.APIresult);
		} catch (error) {
			console.log('There was an issue downloading the file', error);
		}
 	},
 	sharePop: function () {
		if(!this.audioCompression) { 
			this.grabCompressionData() 
		}
		this.localState.shareMode = true;
		this.localState.editMode = false;
		this.localState.ctcMode =  false;
		this.selected = true;
 	},
 	hideSharePop: function (id) {
		this.localState.shareMode = false;
		this.localState.editMode = false;
		this.localState.ctcMode =  false;
		this.localState.sharePopConfirm = '';
		this.callInfoSlide = 1;
		this.localState.shareExpand = false;
		this.selected = false;
 	},
 	play: function () {
 		var filter = $(event.target).attr('id');
		this.localState.playing = true;
		this.localState.paused = false;
 	},
 	pause: function () {
		var filter = $(event.target).attr('id');
		this.localState.playing = false;
		this.localState.paused = true;
	},
	validatePhone: function (currentCallid) {
		var phoneLength = this.directPhoneInput.length;
		let re = /^\d+$/;
		if (phoneLength != 10 || !re.test(String(this.directPhoneInput))) {
			this.localState.invalidPhone = true;
		} else {
			this.localState.invalidPhone = false;
			this.$store.commit({
				type: 'updateLiveListenDID',
				newDID: this.directPhoneInput
			})			
			this.directPhoneInput = this.liveListenDID
			var node = currentCallid.toString().substring(0, 2) + 0 + currentCallid.toString().substring(2, 3)
			this.invokeLiveAudio(currentCallid, this.liveListenDID, node)
		}
	},
	validateEmail: function (email) {
		let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	},
	invokeLiveAudio: async function (currentCallid, directPhone, node) {
		let endpoint = '/asteriskNode/' + node + '?directPhone=' + directPhone + '&callid=' + currentCallid; 
		let res = await this.axios.get(endpoint, {
			responseType: 'json'
		})
		this.localState.initiatingCall = true;	
		var self = this;
        setTimeout(function(){
			self.localState.initiatingCall = false;
			self.localState.listenLive = false;
        }, 2500);
	},
	saveShare: async function() {
		let endpoint = `/calls/${this.call.callid}/share`
		let email = this.shareCallRecipient.replace(/ /g,'')
		let emails = this.shareCallRecipients.slice()
		let validEmail = true
		let whichEmailIsInvalid = ''
		// If multiple addresses entered, then split into array and then combine with the other email array
		if (email.indexOf(',') !== -1) { email = email.split(',') }
		Array.isArray(email) 
			? emails = emails.concat(email) 
			: email !== '' 
				? emails.push(email)
				: //console.log('No manual emails selected')
		// Validate emails
		emails.forEach( (email) => {
			if (!this.validateEmail(email)) {
				this.localState.sharePopConfirm = 'Invalid recipient email(s).'
				whichEmailIsInvalid = email
				validEmail = false
			}
		})
		// Kill if there is an invalid email
		if (validEmail === false) { 
			return false 
		}
		let res = await axios.post(endpoint, {
			subject: this.user.descrip1 ? this.user.descrip1 + ' has shared a call' : 'Someone has shared a call',
			recipients: emails,
			message: this.shareCallMessage,
			lskin: this.account.lskinid,
			leuserid: this.user.leuserid
		})
		.then( () => this.localState.sharePopConfirm = 'Thank you for sharing your call!')
		.catch( () => this.localState.sharePopConfirm = 'An error has occurred.')
	},
	openMxYou: function() {
		// TODO: CHANGE THIS SHIT STEPHEN. - Stephen
		let url = 'http://carwars.com/platform_a/mx_you_enhanced.cfm?phone='
		url = url + this.call.agent.phonecodeid
		url = url + '&cftoken=' + this.cftoken
		url = url + '&cfid=' + this.cfid
		window.open(url)
	},
	loadWaveForm: function() {
		this.localState.loaded = true
	},
	updateAgent: async function() {
		let phonecode = null
		if(this.call.agentSelected && this.call.agentSelected.Phonecode) { phonecode = this.call.agentSelected.Phonecode.phonecodeid }
		this.call.agent = this.call.agentSelected
		let endpoint = `/calls/${this.call.callid}/handledby`
		let res = await axios.post(endpoint, {
			phonecode: phonecode
		})
		.then( () => {
			this.localState.handledByConfirm = '"Handled by" updated.'
		})
		.catch( () => {
			this.localState.handledByConfirm = 'An error has occurred.'
			this.call.agentSelected = this.call.agent
		})
	},
	getSecondsRemoved: function () {
		let seconds = 0;
		if(this.audioCompression) {
			let full = this.audioCompression.full_audio_duration
			let short = this.audioCompression.shortened_audio_duration
			full = full.split(":")
			short = short.split(":")
			let fullDate = new Date(0, 0, 0, full[0], full[1], full[2])
			let shortDate = new Date(0, 0, 0, short[0], short[1], short[2])
			let diff = shortDate.getTime() - fullDate.getTime()
			seconds = Math.floor(diff / 1000)
		}
		return Math.abs(seconds)
	},
	checkIE: function() {
		let ua = window.navigator.userAgent
		let msie = ua.indexOf('MSIE ')

		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv11./) || ua == 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko' || ua == 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729; McAfee; rv:11.0) like Gecko' ) {
			return true
		}
		return false
 	},	
 },	
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>